"use client"

import React, { useState } from "react"
import { ChevronDown, UKFlag, USFlag } from "components/SVG"
import { withErrorBoundary } from "react-error-boundary"
import { Logger } from "lib/logger"
import { color } from "lib/theme/theme.css"
import type { LocaleType } from "lib/apollo/types"
import { changeRegion } from "./CountrySelector.utils"
import {
  countrySelector,
  countrySelectorWrapper,
  countrySelectorButton,
  countrySelectorTextWrapper,
  countrySelectorText,
  countrySelectorMenuList,
  countrySelectorMenuWrapper,
  countrySelectorMenuListOpen,
} from "./CountrySelector.css"

const countryIcons = {
  "en-GB": <UKFlag width="1.5rem" height="0.9rem" />,
  "en-US": <USFlag width="1.5rem" height="0.9rem" />,
}

type Item = {
  locale: LocaleType
  title: string
}

const items: Item[] = [
  {
    locale: "en-GB",
    title: "United Kingdom (GBP)",
  },
  {
    locale: "en-US",
    title: "United States (USD)",
  },
]

type Props = {
  locale: LocaleType
}

const CountrySelectorComp: React.FC<Props> = ({ locale }) => {
  const selected = items.find((item) => item.locale === locale) ?? items[0]
  const menuItems = items.filter((item) => item.locale !== locale) ?? items[0]
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleButtonClick = (menuItemLocale: LocaleType) => {
    changeRegion(menuItemLocale)
  }

  return (
    <div className={countrySelector} data-testid="country-selector">
      <div className={countrySelectorWrapper}>
        <button
          type="button"
          data-testid="CountrySelectorButton"
          className={countrySelectorButton}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <div className={countrySelectorTextWrapper}>
            <p className={countrySelectorText}>
              {countryIcons[selected.locale]}
              {selected.title}
            </p>
            <ChevronDown color={color.contentTertiary} />
          </div>
        </button>

        <div
          className={`${countrySelectorMenuList} ${
            isMenuOpen ? countrySelectorMenuListOpen : ""
          }`}
        >
          <div>
            {menuItems.map((menuItem, index) => {
              const key = `MenuItem-${index}`
              return (
                <button
                  type="button"
                  key={key}
                  data-testid={`${menuItem.locale}-selector`}
                  value={menuItem.locale}
                  onClick={() => {
                    handleButtonClick(menuItem.locale)
                    setIsMenuOpen(false)
                  }}
                >
                  <div className={countrySelectorMenuWrapper}>
                    {countryIcons[menuItem.locale]}
                    <p className={countrySelectorText}>{menuItem.title}</p>
                  </div>
                </button>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export const CountrySelector = withErrorBoundary(CountrySelectorComp, {
  fallback: <div />,
  onError(error) {
    Logger.warn(`Country Selector failed to load. ${error}`)
  },
})
